import * as React from "react";
import { useCallback, useMemo, useRef } from "react";
import { Formik, Form, Field } from "formik";
import styled from "styled-components";
import Button from "components/bootstrap/Button";
import IconButton from "components/common/IconButton";
import ButtonGroup from "components/bootstrap/ButtonGroup";
import ClipboardIconButton from "components/common/ClipboardIconButton";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import UserNotification from "util/UserNotification";
import OverlayTrigger from "components/common/OverlayTrigger";
import { Input } from "components/bootstrap";
const Actions = styled(ButtonGroup)`
  margin-top: 10px;
`;
const ResponseRating = () => {
  const overlay = useRef();
  const sendTelemetry = useSendTelemetry();
  const onRating = useCallback(
    (values) => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.WIDGET_SUMMARY.USER_SURVEY, {
        app_value: values
      });
      UserNotification.success("Thank you for your feedback!");
    },
    [sendTelemetry]
  );
  const onGoodRating = useCallback(() => onRating({ rating: 3 }), [onRating]);
  const onBadRating = useCallback(
    (rating) => {
      onRating(rating);
      overlay.current.hide();
    },
    [onRating]
  );
  const badRatingOverlay = useMemo(
    () => /* @__PURE__ */ React.createElement(Formik, { onSubmit: onBadRating, initialValues: { rating: 1, review: void 0 } }, /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Field, { name: "review" }, ({ field: { name, value, onChange } }) => /* @__PURE__ */ React.createElement(
      Input,
      {
        id: name,
        name,
        type: "textarea",
        value,
        onChange,
        label: /* @__PURE__ */ React.createElement("span", null, "What can be improved? ", /* @__PURE__ */ React.createElement("small", { className: "text-muted" }, "(Optional)")),
        rows: 4
      }
    )), /* @__PURE__ */ React.createElement(Button, { bsSize: "xs", type: "submit" }, "Submit"))),
    [onBadRating]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(IconButton, { name: "thumb_up", iconType: "regular", size: "xs", title: "Great response!", onClick: onGoodRating }), /* @__PURE__ */ React.createElement(OverlayTrigger, { ref: overlay, overlay: badRatingOverlay, placement: "bottom", trigger: "click", rootClose: true }, /* @__PURE__ */ React.createElement(IconButton, { name: "thumb_down", iconType: "regular", size: "xs", title: "Bad response!" })));
};
const ResponseActions = ({ response }) => /* @__PURE__ */ React.createElement(Actions, null, /* @__PURE__ */ React.createElement(ResponseRating, null), /* @__PURE__ */ React.createElement(ClipboardIconButton, { text: response.text, buttonTitle: "Copy response to clipboard" }));
export default ResponseActions;
